var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.378 9.64133e-06C23.4639 -0.00619256 15.8401 2.98019 10.0359 8.36014C4.23161 13.7401 0.676175 21.1157 0.0827285 29.0075C-0.510718 36.8993 1.90171 44.7237 6.83612 50.9112C11.7705 57.0987 18.862 61.1916 26.688 62.369V39.695H18.925V31.447H26.688V25.958C26.688 16.871 31.115 12.882 38.667 12.882C40.8187 12.8534 42.9696 12.9841 45.102 13.273V20.473H39.952C36.746 20.473 35.626 23.512 35.626 26.938V31.446H45.026L43.751 39.694H35.626V62.436C43.5063 61.3644 50.6852 57.339 55.7096 51.1744C60.7341 45.0099 63.2289 37.1667 62.689 29.2322C62.1492 21.2977 58.615 13.8647 52.8019 8.43751C46.9888 3.01032 39.3308 -0.00565556 31.378 9.64133e-06Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.39f216ec6d4c6077523fc6c61e7ed245.svg";
export { ForwardRef as ReactComponent };